import styled from '@emotion/styled';

export default styled('div')`
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
`;
